export default [
  {
    path: '/index',
    name: 'index',
    component: () => import('@/views/indexPage/index'),
    meta: { title: '造价云管理平台', icon: 'home', noCache: true, keepAlive: false, auth: false }
  },
  {
    path: '/free-license',
    name: 'FreeLicense',
    component: () => import('@/views/indexPage/freeLicense'),
    meta: { title: '体验中心', icon: 'home', noCache: true, keepAlive: false, auth: false }
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/indexPage/cfmcc'),
    meta: { title: '造价云管理平台', icon: 'home', noCache: true, keepAlive: false, auth: false }
  },
  {
    path: '/findAdmin',
    name: 'findAdmin',
    component: () => import('@/views/indexPage/findAdmin.vue'),
    meta: { title: '造价云管理平台', icon: 'home', noCache: true, keepAlive: false, auth: false }
  },
  {
    path: '/vip',
    name: 'vip',
    component: () => import('@/views/indexPage/vip'),
    meta: { title: '造价云管理平台', icon: 'home', noCache: true, keepAlive: false, auth: false }
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: () => import('@/views/indexPage/privacy.vue'),
    meta: { title: '隐私政策-造价云管理平台', icon: 'home', noCache: true, keepAlive: false, auth: false }
  },
  {
    path: '/agreement',
    name: 'Agreement',
    component: () => import('@/views/indexPage/agreement.vue'),
    meta: { title: '用户协议-造价云管理平台', icon: 'home', noCache: true, keepAlive: false, auth: false }
  },
  {
    path: '/production',
    name: 'production',
    component: () => import('@/views/indexPage/production'),
    meta: { title: '造价云管理平台', icon: 'home', noCache: true, keepAlive: false, auth: false }
  }
]
